var _title, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10.486 28.858 331.628 42.425",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RBI-Logo-Bank-Hz-Squared-Col-Pos-CMYK-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clear Space - DO NOT PRINT",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0.013992, 0.003338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "RBI-Logo-Bank-St-Squared-Col-Pos-CMYK-ai")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    transform: "matrix(0.086853, 0, 0, 0.086853, 10.515182, 28.903072)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m518.9 225l-24.5-44.6h-9.9v44.6h-23.9v-112.7h45.2q11.6 0 20.1 3.9 8.5 3.9 12.9 11.3 4.5 7.5 4.5 17.9 0 12.3-6.5 20.6-6.6 8.3-18.7 11.6l27.4 47.4zm-34.5-92.2v28.7h18.6q7.4 0 11.4-3.7 4-3.8 4-10.9 0-7.4-4-10.8-4-3.3-11.6-3.3z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m613.9 137.3h22.7v87.7h-22.7v-10.5q-4.3 6-10.9 9.4-6.6 3.4-14.9 3.4-10.8 0-19.3-5.9-8.4-5.9-13.1-16.4-4.8-10.5-4.8-23.8 0-13.4 4.8-23.9 4.7-10.5 13.1-16.4 8.5-5.9 19.3-5.9 8.3 0 14.9 3.5 6.6 3.4 10.9 9.4zm-8.9 66.5q4.4-3 7-8.7 2.6-5.7 2.6-13.9 0-8.1-2.6-13.8-2.6-5.7-7-8.7-4.5-3-10.3-3-5.8 0-10.4 3-4.5 3-7 8.7-2.5 5.7-2.5 13.8 0 8.2 2.5 13.9 2.5 5.7 7 8.7 4.6 3 10.4 3 5.8 0 10.3-3z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m657.9 121.3q-3.7-3.7-3.7-9.7 0-6 3.7-9.7 3.8-3.7 9.7-3.7 6 0 9.6 3.7 3.7 3.7 3.7 9.7 0 6-3.7 9.7-3.6 3.7-9.6 3.7-5.9 0-9.7-3.7zm20.8 103.7h-22.7v-87.7h22.7z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m727.3 137.3h24v19.9h-24v67.8h-22.7v-67.8h-14.9v-19.9h14.9v-5.3q0-14.4 8.3-22 8.3-7.7 22.7-7.7 5.3 0 10.1 1 4.8 1 8.8 2.7l-5.8 17.4q-4.5-1.8-9.8-1.8-6.1 0-8.9 2.8-2.7 2.8-2.7 8.6z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m785.3 137.3h24v19.9h-24v67.8h-22.7v-67.8h-14.9v-19.9h14.9v-5.3q0-14.4 8.3-22 8.3-7.7 22.7-7.7 5.3 0 10.1 1 4.8 1 8.8 2.7l-5.8 17.4q-4.5-1.8-9.8-1.8-6.1 0-8.9 2.8-2.7 2.8-2.7 8.6z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m897.7 189.2h-59.2q1.2 9.9 6.5 14.4 5.3 4.5 15.6 4.5 7.1 0 13.1-2.1 6.1-2.1 10.6-5.9l9.8 15.6q-6.7 5.6-15.5 8.6-8.8 3-18.9 3-14.2 0-24.5-5.5-10.3-5.4-15.7-15.7-5.3-10.3-5.3-24.4 0-13.9 5.3-24.5 5.3-10.6 15-16.4 9.7-5.8 22.1-5.8 12.4 0 21.7 5.6 9.3 5.7 14.3 16.1 5.1 10.4 5.1 24.5zm-59.2-15.6h36.3q-0.8-9.7-5.4-14.5-4.7-4.8-12.6-4.8-16 0-18.3 19.3z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m913.5 121.3q-3.7-3.7-3.7-9.7 0-6 3.7-9.7 3.8-3.7 9.7-3.7 6 0 9.6 3.7 3.7 3.7 3.7 9.7 0 6-3.7 9.7-3.6 3.7-9.6 3.7-5.9 0-9.7-3.7zm20.8 103.7h-22.7v-87.7h22.7z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m963.3 224.4q-9.2-2.9-15.7-9l10.6-16.3q9.8 9.3 24.9 9.3 6.6 0 10-2.1 3.4-2 3.4-6.2 0-3.5-3.1-5.7-3-2.2-11.2-4.2-10.4-2.3-17.1-5.2-6.7-2.8-10.9-7.9-4.1-5.2-4.1-13.4 0-8.8 4.5-15.3 4.4-6.5 12.7-9.9 8.3-3.5 19.2-3.5 10.3 0 19 3 8.7 2.9 14.9 8.8l-10.7 15.5q-4.4-4.1-10.6-6.3-6.1-2.1-12.7-2.1-6.3 0-9.6 2-3.4 2-3.4 5.9 0 2.4 1.5 3.9 1.4 1.6 4.8 3.1 3.5 1.5 10 3 8.9 2.1 15.4 5.1 6.5 3 10.6 8.5 4.2 5.4 4.2 13.9 0 8.5-4.4 14.7-4.3 6.3-12.5 9.8-8.3 3.5-19.9 3.5-10.5 0-19.8-2.9z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m1112.7 189.2h-59.2q1.2 9.9 6.5 14.4 5.3 4.5 15.6 4.5 7.1 0 13.1-2.1 6.1-2.1 10.6-5.9l9.7 15.6q-6.6 5.6-15.4 8.6-8.8 3-18.9 3-14.2 0-24.5-5.5-10.3-5.4-15.7-15.7-5.4-10.3-5.4-24.4 0-13.9 5.3-24.5 5.3-10.6 15-16.4 9.7-5.8 22.2-5.8 12.4 0 21.7 5.6 9.3 5.7 14.3 16.1 5.1 10.4 5.1 24.5zm-59.2-15.6h36.3q-0.8-9.7-5.5-14.5-4.6-4.8-12.6-4.8-15.9 0-18.2 19.3z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m1191.8 139q7.1 4.1 10.9 11.9 3.8 7.8 3.8 18.7v55.4h-22.9v-52.6q0-8.4-3.9-12.6-3.9-4.3-11.8-4.3-6 0-10.5 2.7-4.6 2.6-8.1 7.9v58.9h-22.7v-87.7h22.7v10.3q4.2-6 10.9-9.3 6.7-3.3 15-3.3 9.6 0 16.6 4z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m538.8 326.3q4.8 6.9 4.8 16.8 0 15.4-9.8 23.8-9.9 8.4-28 8.4h-45.2v-112.7h41.3q17.9 0 27.7 7.7 9.7 7.7 9.7 21.8 0 16.7-14.4 24 9.1 3.3 13.9 10.2zm-54.3-43.5v26.3h15.5q7.7 0.1 11.2-3.3 3.6-3.3 3.6-9.7 0-7.2-3.8-10.2-3.8-3.1-11.5-3.1zm18.6 72.3q7.8 0 11.7-3.4 3.9-3.3 3.9-10.6 0-6.8-3.7-10.1-3.8-3.3-12.4-3.3h-18.1v27.4z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    className: "s0",
    d: "m615.4 287.6h22.7v87.7h-22.7v-10.5q-4.3 6-10.9 9.4-6.7 3.4-14.9 3.4-10.8 0-19.3-5.9-8.4-5.9-13.2-16.4-4.7-10.5-4.7-23.8 0-13.4 4.7-23.9 4.8-10.6 13.2-16.4 8.5-5.9 19.3-5.9 8.2 0 14.9 3.5 6.6 3.4 10.9 9.4zm-8.9 66.5q4.4-3 7-8.7 2.6-5.7 2.6-13.9 0-8.1-2.6-13.8-2.6-5.7-7-8.7-4.5-3-10.3-3-5.8 0-10.4 3-4.5 3-7 8.7-2.5 5.7-2.5 13.8 0 8.2 2.5 13.9 2.5 5.7 7 8.7 4.6 3 10.4 3 5.8 0 10.3-3z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m722.7 289.3q7.1 4.1 10.9 11.9 3.8 7.8 3.8 18.7v55.4h-22.9v-52.6q0-8.4-3.9-12.6-3.9-4.3-11.8-4.3-6 0-10.5 2.7-4.6 2.6-8.1 7.9v58.9h-22.7v-87.7h22.7v10.3q4.2-6 10.9-9.3 6.7-3.3 15-3.3 9.6 0 16.6 4z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s0",
    d: "m799.7 328.5l35.2 46.8h-27.2l-30-39.8v39.8h-22.7v-119.4h22.7v67.3l28.5-35.6h27z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m375.7 375.3h-263v-263h263z",
    style: {
      fill: "rgb(255, 241, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m302.9 225.1l33.5-33.5 9 8.9c0-5.8-1.7-25.6-17.6-41.1-17.8-17.3-35.6-7.2-41.7-1.1l-32.3 32.3 8 8-17.6 17.6-17.5-17.6 7.9-8-32.2-32.3c-6.2-6.1-24-16.2-41.8 1.1-15.9 15.5-17.6 35.3-17.6 41.1h0.1l8.9-8.9 33.5 33.5 9.3-9.3v-22l9.5 9.5v26.7l13.1 13.1-67.9 67.8 26.8 26.9 67.9-67.9 67.9 67.9 26.9-26.9-67.9-67.8 13.1-13.1v-26.7l9.5-9.5v22z",
    style: {
      fill: "rgb(30, 28, 2)"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 125.106,
    y: 38.659,
    width: 0.6,
    height: 22.836,
    style: {
      fillRule: "evenodd",
      paintOrder: "stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.036814, 0, 0, 0.036814, 170.170853, 43.532772)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    d: "M 430.533 21.354 C 384.283 0.844 334.613 -10.076 283.863 -5.966 C 257.633 -3.836 220.513 7.874 213.353 37.634 C 207.733 61.014 227.753 77.834 244.923 88.814 C 254.853 95.164 265.043 101.064 275.503 106.514 C 341.543 140.914 419.553 179.374 428.823 263.974 C 429.893 273.774 430.103 284.134 429.433 295.044 C 423.233 397.324 343.423 458.374 249.903 478.494 C 214.853 486.034 179.403 489.054 143.553 487.554 C 97.073 485.614 47.163 478.064 2.283 462.354 C -2.267 460.754 -7.277 458.684 -12.727 456.144 C -12.987 456.024 -13.127 455.744 -13.067 455.464 L 14.863 324.964 C 14.953 324.534 15.203 324.414 15.593 324.594 C 30.863 331.684 41.703 336.534 48.123 339.164 C 85.653 354.544 124.623 362.244 165.053 362.254 C 173.523 362.254 180.183 362.094 185.053 361.764 C 215.443 359.714 260.843 346.764 266.553 310.604 C 271.793 277.374 240.133 258.014 215.573 244.174 C 198.183 234.374 172.983 223.014 152.083 210.964 C 122.563 193.934 94.493 171.984 74.913 143.884 C 57.993 119.594 50.163 92.184 50.873 62.714 C 51.753 26.194 62.803 -6.726 84.033 -36.046 C 127.363 -95.896 203.643 -124.276 274.813 -130.666 C 337.703 -136.306 398.763 -128.036 457.983 -105.866 C 458.253 -105.756 458.363 -105.566 458.303 -105.276 L 431.243 20.994 C 431.153 21.404 430.923 21.524 430.533 21.354 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    d: "M -941.947 -103.776 L -941.947 -105.256 L -938.457 -121.036 C -938.387 -121.366 -938.187 -121.526 -937.857 -121.526 C -852.627 -121.526 -767.417 -121.526 -682.207 -121.526 C -673.157 -121.526 -666.517 -121.186 -662.267 -120.496 C -633.157 -115.786 -611.117 -94.196 -603.787 -65.756 C -603.477 -64.556 -602.207 -58.006 -599.957 -46.116 C -579.187 64.184 -558.377 174.694 -537.547 285.414 C -537.427 286.034 -537.247 286.054 -537.017 285.464 L -376.197 -121.116 C -376.087 -121.386 -375.887 -121.526 -375.597 -121.526 L -213.467 -121.526 C -212.977 -121.526 -212.827 -121.296 -213.017 -120.846 L -464.017 478.004 C -464.147 478.314 -464.377 478.474 -464.717 478.474 L -627.937 478.474 C -628.267 478.474 -628.477 478.314 -628.567 477.984 C -670.427 316.054 -712.277 154.124 -754.127 -7.786 C -759.267 -27.686 -768.477 -41.956 -786.987 -51.736 C -805.317 -61.426 -824.297 -69.656 -843.917 -76.426 C -876.047 -87.496 -908.717 -96.616 -941.947 -103.776 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    d: "M 8.783 -121.056 L -119.397 478.164 C -119.437 478.344 -119.597 478.474 -119.787 478.474 L -274.387 478.474 C -274.637 478.474 -274.817 478.244 -274.767 478.004 L -146.547 -121.216 C -146.507 -121.396 -146.347 -121.526 -146.157 -121.526 L 8.403 -121.526 C 8.653 -121.526 8.833 -121.296 8.783 -121.056 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    d: "M 978.053 477.154 L 978.053 478.454 L 834.933 478.454 C 834.603 478.454 834.413 478.294 834.343 477.974 L 815.833 389.434 C 815.763 389.124 815.573 388.974 815.263 388.974 L 617.303 388.974 C 617.013 388.974 616.823 389.114 616.723 389.384 L 584.733 477.984 C 584.613 478.314 584.383 478.474 584.043 478.474 L 421.613 478.474 C 421.483 478.474 421.393 478.334 421.443 478.214 C 498.173 295.054 574.903 111.874 651.643 -71.326 C 655.033 -79.416 657.983 -85.386 660.483 -89.216 C 671.623 -106.306 687.343 -116.676 707.633 -120.326 C 712.183 -121.146 718.823 -121.556 727.553 -121.546 C 769.133 -121.516 810.733 -121.506 852.343 -121.536 C 852.733 -121.536 852.963 -121.346 853.033 -120.966 L 978.053 477.154 Z M 661.813 265.304 C 661.743 265.514 661.893 265.724 662.103 265.724 L 789.563 265.724 C 789.763 265.724 789.903 265.544 789.863 265.354 L 743.303 42.264 C 743.243 41.954 742.813 41.924 742.713 42.224 L 661.813 265.304 Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 215.973,
    y: 38.659,
    width: 0.6,
    height: 22.836,
    style: {
      fillRule: "evenodd",
      paintOrder: "stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.315752, 0, 0, 0.315752, 220.747818, 33.035595)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 152.4,
    height: 108,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 25.7,
    className: "st1",
    width: 31.5,
    height: 56.6,
    style: {
      fill: "rgb(255, 95, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3 c13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z",
    style: {
      fill: "rgb(235, 0, 27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6 c15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z",
    style: {
      fill: "rgb(247, 158, 27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.15823, 0, 0, 0.15823, 282.162506, 37.273479)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.45,50.28c-9.5-20.15-29.57-32.3-52.34-32.3c-28.85,0-55.65,19.38-65.12,46.13 c11.24-32.72,41.64-54.69,74.37-54.69c25.83,0,48.59,13.78,59.99,36.43l-4.27,6.7L253.45,50.28L253.45,50.28z M245.37,101.31 c1.52-1.38,2.58-3.03,3.18-4.92c0.6-1.9,1.08-3.69,1.44-5.39l3.01-13.26c0.36-1.43,0.58-2.53,0.67-3.32 c0.09-0.78,0.13-1.37,0.13-1.78c0-0.4-0.1-0.9-0.3-1.51c-0.2-0.6-0.7-1.28-1.51-2.04h9.71c0.94,0,1.83-0.11,2.68-0.33 c0.85-0.22,1.72-0.56,2.61-1l-1.54,6.83c0.45-0.76,1-1.53,1.67-2.31c0.67-0.78,1.43-1.48,2.28-2.11c0.85-0.62,1.79-1.13,2.81-1.51 c1.03-0.38,2.14-0.55,3.35-0.5l1.54,0.07l-2.21,10.05c-0.76-0.63-1.47-1.03-2.14-1.21c-0.67-0.18-1.18-0.27-1.54-0.27 c-1.29,0-2.44,0.31-3.45,0.94c-1,0.63-1.82,1.41-2.45,2.34c-0.36,0.49-0.67,1.06-0.94,1.71c-0.27,0.65-0.51,1.31-0.74,1.98 c-0.22,0.67-0.41,1.28-0.57,1.84c-0.16,0.56-0.26,0.99-0.3,1.31l-0.87,4.09c-0.09,0.4-0.19,0.88-0.3,1.44 c-0.11,0.56-0.22,1.16-0.33,1.81c-0.11,0.65-0.21,1.27-0.3,1.88c-0.09,0.6-0.13,1.13-0.13,1.57c0,0.98,0.13,1.76,0.4,2.34 c0.27,0.58,0.51,1,0.74,1.27H245.37L245.37,101.31z M25.14,94.34c0.63,0.22,1.28,0.39,1.98,0.5c0.69,0.11,1.35,0.17,1.98,0.17 c1.61,0,3.3-0.45,5.09-1.34c1.79-0.89,3.44-2.31,4.96-4.25c1.52-1.94,2.78-4.42,3.78-7.44c1-3.01,1.51-6.64,1.51-10.88 c0-2.72-0.37-4.83-1.11-6.33c-0.74-1.5-1.61-2.59-2.61-3.28c-1-0.69-2.03-1.11-3.08-1.24c-1.05-0.13-1.86-0.2-2.44-0.2 c-0.49,0-0.86,0.01-1.11,0.03c-0.25,0.02-0.7,0.12-1.37,0.3L25.14,94.34L25.14,94.34z M7.53,101.31c0.98-0.71,1.79-1.45,2.41-2.21 c0.63-0.76,1.14-1.57,1.54-2.44c0.4-0.87,0.73-1.78,0.97-2.71c0.25-0.94,0.48-1.92,0.7-2.95l5.83-26.26 c0.45-1.96,0.7-3.37,0.77-4.22c0.07-0.85,0.1-1.41,0.1-1.67c0-0.63-0.12-1.3-0.37-2.01c-0.25-0.71-0.77-1.52-1.57-2.41h20.5 c2.72,0,5.15,0.21,7.27,0.64c2.12,0.42,4.05,1.22,5.79,2.38c2.37,1.61,4.06,3.73,5.09,6.36c1.03,2.63,1.54,5.6,1.54,8.91 c0,2.32-0.26,4.63-0.77,6.93c-0.51,2.3-1.25,4.49-2.21,6.56c-0.96,2.08-2.17,4.02-3.62,5.83c-1.45,1.81-3.11,3.38-4.99,4.72 c-2.32,1.65-4.89,2.82-7.7,3.52c-2.81,0.69-6.27,1.04-10.38,1.04H7.53L7.53,101.31z M74.24,52.68c1.88,0,3.37,0.55,4.49,1.64 c1.12,1.09,1.67,2.58,1.67,4.45c0,2.19-0.67,3.97-2.01,5.36c-1.34,1.38-3.04,2.08-5.09,2.08c-2.01,0-3.59-0.59-4.76-1.78 c-1.16-1.18-1.74-2.71-1.74-4.59c0-2.14,0.67-3.87,2.01-5.19C70.15,53.34,71.96,52.68,74.24,52.68L74.24,52.68z M71.89,69.09 c1.74,0,3.11-0.17,4.12-0.5c1-0.33,1.75-0.61,2.24-0.84l-5.02,22.77c-0.09,0.31-0.19,0.76-0.3,1.34c-0.11,0.58-0.17,1.09-0.17,1.54 c0,0.49,0.09,0.86,0.27,1.11c0.18,0.25,0.39,0.44,0.64,0.57c0.25,0.13,0.49,0.21,0.74,0.23c0.25,0.02,0.46,0.03,0.64,0.03 c0.71,0,1.27-0.07,1.67-0.2c0.4-0.13,0.71-0.25,0.94-0.34l-4.76,6.1c-1.29,0.63-2.43,1-3.42,1.14c-0.98,0.13-1.85,0.2-2.61,0.2 c-0.63,0-1.31-0.07-2.04-0.2c-0.74-0.13-1.42-0.42-2.04-0.87c-0.63-0.45-1.15-1.08-1.57-1.91c-0.42-0.83-0.64-1.93-0.64-3.32 c0-1.03,0.09-1.94,0.27-2.75c0.18-0.8,0.38-1.7,0.6-2.68l2.81-12.79c0.04-0.27,0.11-0.6,0.2-1c0.09-0.4,0.18-0.85,0.27-1.34 c0.09-0.49,0.17-0.97,0.23-1.44c0.07-0.47,0.1-0.9,0.1-1.31c0-0.89-0.22-1.64-0.67-2.24c-0.45-0.6-0.8-1.04-1.07-1.31H71.89 L71.89,69.09z M77.99,101.31H94.6c-0.22-0.27-0.47-0.69-0.74-1.27c-0.27-0.58-0.4-1.36-0.4-2.34c0-0.45,0.04-0.97,0.13-1.57 c0.09-0.6,0.19-1.23,0.3-1.88c0.11-0.65,0.22-1.25,0.33-1.81c0.11-0.56,0.21-1.04,0.3-1.44l1.54-7.43c0.49-2.28,1.15-4.1,1.98-5.46 c0.83-1.36,2.13-2.04,3.92-2.04c0.18,0,0.44,0.02,0.77,0.07c0.34,0.04,0.66,0.17,0.97,0.37c0.31,0.2,0.59,0.5,0.84,0.9 c0.25,0.4,0.37,0.98,0.37,1.74c0,0.27-0.02,0.56-0.07,0.87c-0.04,0.31-0.11,0.58-0.2,0.8l-2.34,10.32 c-0.22,0.94-0.42,1.75-0.6,2.44c-0.18,0.69-0.27,1.42-0.27,2.18c0,0.67,0.1,1.4,0.3,2.18c0.2,0.78,0.57,1.48,1.11,2.11 c0.54,0.63,1.27,1.15,2.21,1.57c0.94,0.42,2.14,0.64,3.62,0.64c1.29,0,2.41-0.13,3.35-0.4c0.94-0.27,1.76-0.58,2.48-0.94l4.76-6.16 c-0.36,0.13-0.84,0.27-1.44,0.4c-0.6,0.13-1.17,0.2-1.71,0.2c-0.94,0-1.53-0.25-1.77-0.74c-0.25-0.49-0.37-0.96-0.37-1.41 c0-0.13,0.01-0.41,0.03-0.84c0.02-0.42,0.14-1.06,0.37-1.91l2.01-9.18c0.36-1.52,0.57-2.67,0.64-3.45c0.07-0.78,0.1-1.35,0.1-1.71 c0-1.21-0.23-2.29-0.7-3.25c-0.47-0.96-1.12-1.8-1.94-2.51c-0.83-0.71-1.79-1.26-2.88-1.64c-1.09-0.38-2.27-0.57-3.52-0.57 c-0.36,0-0.86,0.03-1.51,0.1s-1.41,0.26-2.28,0.57c-0.87,0.31-1.81,0.79-2.81,1.44c-1,0.65-2.02,1.55-3.05,2.71l1.21-5.22 c-0.89,0.45-1.76,0.78-2.61,1c-0.85,0.22-1.74,0.33-2.68,0.33h-9.71c0.8,0.76,1.31,1.44,1.51,2.04c0.2,0.6,0.3,1.1,0.3,1.51 c0,0.4-0.04,0.99-0.13,1.78c-0.09,0.78-0.31,1.89-0.67,3.32l-3.01,13.26c-0.36,1.7-0.84,3.49-1.44,5.39 C80.57,98.28,79.51,99.92,77.99,101.31L77.99,101.31z M138.27,101.64c-0.49,0.13-1.06,0.27-1.71,0.4c-0.65,0.13-1.42,0.2-2.31,0.2 c-1.47,0-2.9-0.22-4.29-0.67c-1.38-0.45-2.62-1.14-3.72-2.08c-1.09-0.94-1.97-2.17-2.61-3.68c-0.65-1.52-0.97-3.35-0.97-5.49 c0-1.34,0.13-2.75,0.4-4.22c0.27-1.47,0.69-2.95,1.27-4.42c0.58-1.47,1.35-2.91,2.31-4.32c0.96-1.41,2.11-2.71,3.45-3.92 c0.8-0.71,1.69-1.4,2.65-2.04c0.96-0.65,2.05-1.21,3.28-1.67c1.23-0.47,2.59-0.85,4.09-1.14c1.5-0.29,3.18-0.44,5.06-0.44 c0.94,0,1.82,0.04,2.65,0.13c0.83,0.09,1.62,0.18,2.38,0.27c0.94,0.09,1.76,0.18,2.48,0.27c0.71,0.09,1.43,0.13,2.14,0.13 c0.89,0,1.85-0.08,2.88-0.23c1.03-0.16,2.12-0.55,3.28-1.17l-5.02,22.91c-0.09,0.4-0.19,0.85-0.3,1.34 c-0.11,0.49-0.17,0.98-0.17,1.47c0,0.58,0.16,1.07,0.47,1.47c0.31,0.4,0.92,0.6,1.81,0.6c0.49,0,1-0.06,1.54-0.17 c0.54-0.11,1.05-0.26,1.54-0.44l-4.76,6.16c-1.03,0.54-2.02,0.89-2.98,1.07c-0.96,0.18-1.89,0.27-2.78,0.27 c-0.49,0-1.15-0.04-1.98-0.13c-0.83-0.09-1.63-0.36-2.41-0.8c-0.78-0.45-1.45-1.13-2.01-2.04c-0.56-0.92-0.84-2.2-0.84-3.85 c0-0.31,0.02-0.6,0.07-0.87c0.04-0.27,0.1-0.58,0.17-0.94c0.07-0.36,0.16-0.78,0.27-1.27c0.11-0.49,0.26-1.12,0.44-1.88l3.42-15.2 c-0.36-0.22-0.83-0.46-1.41-0.7c-0.58-0.25-1.21-0.37-1.88-0.37c-1.21,0-2.37,0.48-3.48,1.44c-1.12,0.96-2.09,2.19-2.91,3.68 c-0.83,1.5-1.48,3.17-1.98,5.02c-0.49,1.85-0.74,3.67-0.74,5.46c0,2.1,0.56,3.61,1.67,4.52c1.12,0.92,2.43,1.37,3.95,1.37 c0.22,0,0.41-0.01,0.57-0.03c0.16-0.02,0.3-0.06,0.44-0.1L138.27,101.64z",
    style: {
      clipRule: "evenodd",
      fill: "rgb(197, 47, 51)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.89,112.22c9.5,20.15,29.57,32.3,52.34,32.3c28.85,0,55.65-19.38,65.12-46.13 c-11.24,32.72-41.64,54.69-74.37,54.69c-25.83,0-48.59-13.78-59.99-36.43l4.26-6.7L155.89,112.22L155.89,112.22z M311.75,54.42 c0.76,0,1.66-0.11,2.71-0.34c1.05-0.22,1.89-0.54,2.51-0.94l-8.24,37.31c-0.22,0.89-0.36,1.55-0.4,1.98 c-0.04,0.42-0.07,0.7-0.07,0.84c0,0.49,0.09,0.87,0.27,1.14c0.18,0.27,0.38,0.47,0.6,0.6c0.22,0.13,0.47,0.22,0.74,0.27 c0.27,0.04,0.51,0.07,0.74,0.07c0.36,0,0.79-0.03,1.31-0.1c0.51-0.07,1.17-0.23,1.98-0.5l-4.82,6.16c-1.21,0.63-2.3,1-3.28,1.14 c-0.98,0.13-1.79,0.2-2.41,0.2c-1.56,0-2.81-0.2-3.75-0.6c-0.94-0.4-1.66-0.92-2.18-1.54c-0.51-0.63-0.85-1.31-1-2.04 c-0.16-0.74-0.23-1.44-0.23-2.11c0-0.8,0.08-1.6,0.23-2.38c0.16-0.78,0.37-1.82,0.64-3.11l3.28-15.07c-0.67-0.54-1.27-0.87-1.81-1 c-0.54-0.13-0.98-0.2-1.34-0.2c-1.21,0-2.34,0.48-3.42,1.44c-1.07,0.96-2.01,2.19-2.81,3.68c-0.8,1.5-1.43,3.18-1.88,5.06 c-0.45,1.88-0.67,3.71-0.67,5.49c0,0.49,0.04,1.06,0.13,1.71c0.09,0.65,0.31,1.28,0.67,1.91c0.36,0.63,0.87,1.15,1.54,1.57 c0.67,0.42,1.61,0.64,2.81,0.64c0.27,0,0.49-0.01,0.67-0.03c0.18-0.02,0.36-0.06,0.54-0.1l-3.55,6.23 c-1.3,0.31-2.66,0.47-4.09,0.47c-0.58,0-1.51-0.09-2.78-0.27c-1.27-0.18-2.55-0.66-3.82-1.44c-1.27-0.78-2.39-1.99-3.35-3.62 c-0.96-1.63-1.44-3.9-1.44-6.8c0-3.17,0.65-6.25,1.94-9.24c1.29-2.99,3.13-5.56,5.49-7.7c2.32-2.1,4.63-3.46,6.93-4.09 c2.3-0.62,4.61-0.94,6.93-0.94c0.89,0,1.63,0.02,2.21,0.07c0.58,0.04,1.45,0.18,2.61,0.4l1.27-5.56c0.36-1.43,0.57-2.48,0.64-3.15 c0.07-0.67,0.1-1.12,0.1-1.34c0-0.58-0.09-1.23-0.27-1.94c-0.18-0.71-0.69-1.45-1.54-2.21H311.75L311.75,54.42z M222.93,101.64 l3.42-6.1c-0.13,0.04-0.28,0.08-0.44,0.1c-0.16,0.02-0.35,0.03-0.57,0.03c-1.52,0-2.84-0.46-3.95-1.37 c-1.12-0.92-1.67-2.42-1.67-4.52c0-1.79,0.25-3.61,0.74-5.46c0.49-1.85,1.15-3.53,1.98-5.02c0.83-1.5,1.8-2.72,2.91-3.68 c1.12-0.96,2.28-1.44,3.48-1.44c0.67,0,1.29,0.12,1.88,0.37c0.58,0.25,1.05,0.48,1.41,0.7l-3.42,15.2 c-0.18,0.76-0.32,1.38-0.44,1.88c-0.11,0.49-0.2,0.92-0.27,1.27c-0.07,0.36-0.12,0.67-0.17,0.94c-0.04,0.27-0.07,0.56-0.07,0.87 c0,1.65,0.28,2.94,0.84,3.85c0.56,0.92,1.23,1.6,2.01,2.04c0.78,0.45,1.59,0.71,2.41,0.8c0.83,0.09,1.48,0.13,1.98,0.13 c0.89,0,1.82-0.09,2.78-0.27c0.96-0.18,1.95-0.54,2.98-1.07l4.76-6.16c-0.49,0.18-1,0.32-1.54,0.44c-0.54,0.11-1.05,0.17-1.54,0.17 c-0.89,0-1.5-0.2-1.81-0.6c-0.31-0.4-0.47-0.89-0.47-1.47c0-0.49,0.06-0.98,0.17-1.47c0.11-0.49,0.21-0.94,0.3-1.34l5.02-22.91 c-1.16,0.62-2.26,1.02-3.28,1.17c-1.03,0.16-1.99,0.23-2.88,0.23c-0.71,0-1.43-0.04-2.14-0.13c-0.71-0.09-1.54-0.18-2.48-0.27 c-0.76-0.09-1.55-0.18-2.38-0.27c-0.83-0.09-1.71-0.13-2.65-0.13c-1.88,0-3.56,0.15-5.06,0.44c-1.5,0.29-2.86,0.67-4.09,1.14 c-1.23,0.47-2.32,1.03-3.28,1.67c-0.96,0.65-1.84,1.33-2.65,2.04c-1.34,1.21-2.49,2.51-3.45,3.92c-0.96,1.41-1.73,2.85-2.31,4.32 c-0.58,1.47-1,2.95-1.27,4.42c-0.27,1.47-0.4,2.88-0.4,4.22c0,2.14,0.32,3.97,0.97,5.49c0.65,1.52,1.52,2.75,2.61,3.68 c1.09,0.94,2.33,1.63,3.72,2.08c1.38,0.45,2.81,0.67,4.29,0.67c0.89,0,1.66-0.07,2.31-0.2 C221.87,101.91,222.44,101.77,222.93,101.64L222.93,101.64z M198.69,99.7l5.02-9.04c-1.83,1.16-3.49,2.05-4.99,2.68 c-1.5,0.63-2.81,1.09-3.95,1.41c-1.14,0.31-2.09,0.49-2.85,0.54c-0.76,0.04-1.32,0.07-1.67,0.07c-1.79,0-3.3-0.27-4.55-0.8 c-1.25-0.54-2.3-1.24-3.15-2.11c-0.85-0.87-1.51-1.83-1.98-2.88c-0.47-1.05-0.81-2.08-1.04-3.08c-0.22-1-0.37-1.93-0.44-2.78 c-0.07-0.85-0.1-1.5-0.1-1.94c0-3.35,0.45-6.34,1.34-8.97c0.89-2.63,2.08-4.87,3.55-6.7c1.47-1.83,3.17-3.24,5.09-4.22 c1.92-0.98,3.88-1.47,5.89-1.47c0.31,0,0.84,0.03,1.57,0.1c0.74,0.07,1.57,0.26,2.51,0.57c0.94,0.31,1.92,0.79,2.95,1.44 c1.03,0.65,1.99,1.57,2.88,2.78l1.14-9.91c-2.23-0.76-4.29-1.26-6.16-1.51c-1.88-0.25-3.64-0.37-5.29-0.37 c-3.35,0-6.71,0.46-10.08,1.37c-3.37,0.92-6.55,2.69-9.54,5.33c-1.56,1.38-2.94,2.95-4.12,4.69c-1.18,1.74-2.17,3.58-2.95,5.53 c-0.78,1.94-1.36,3.93-1.74,5.96c-0.38,2.03-0.57,4.03-0.57,5.99c0,2.5,0.38,4.95,1.14,7.33c0.76,2.39,1.96,4.51,3.62,6.36 c1.65,1.85,3.81,3.35,6.46,4.49c2.66,1.14,5.91,1.71,9.75,1.71c1.88,0,3.84-0.17,5.89-0.5C194.38,101.41,196.5,100.73,198.69,99.7z ",
    style: {
      clipRule: "evenodd",
      fill: "rgb(6, 75, 118)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 272.966,
    y: 38.659,
    width: 0.6,
    height: 22.836,
    style: {
      fillRule: "evenodd",
      paintOrder: "stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    transform: "matrix(1, 0, 0, 1, 0.013992, 0.003338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "s2",
    d: "",
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanka);
export default __webpack_public_path__ + "static/media/banka.2a08fc51e4f6b86ed27ee1c17218ecba.svg";
export { ForwardRef as ReactComponent };